import Vue from 'vue'
import { URL_DICTIONARIES, URL_PRODUCTS } from '@/constants/urls.js'
import { DICTIONARIES, ERRORS, AXIOS_REQUESTS } from '@/constants/store.js'

const state = {
  [DICTIONARIES.STATE.BIK]: null,
  [DICTIONARIES.STATE.COUNTRIES]: null,
  [DICTIONARIES.STATE.CATEGORY_TYPES]: null,
  [DICTIONARIES.STATE.PRODUCT_SECTIONS]: null
}

const actions = {
  async [DICTIONARIES.ACTIONS.GET_IDENTITY_DICTIONARY_ITEMS] ({ dispatch, commit }, model) {
    const dictionaryType = model.dictionaryType
    model = {
      url: `${Vue.getIdentityHost()}${URL_DICTIONARIES}/${model.dictionaryType}?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(DICTIONARIES.MUTATIONS.GET_DICTIONARY_ITEMS, { dictionaryType, items: resp.data })
  },
  async [DICTIONARIES.ACTIONS.GET_BUSINESS_DICTIONARY_ITEMS] ({ dispatch, commit }, model) {
    const dictionaryType = model.dictionaryType
    model = {
      url: `${Vue.getBusinessHost()}${URL_DICTIONARIES}/${model.dictionaryType}?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(DICTIONARIES.MUTATIONS.GET_DICTIONARY_ITEMS, { dictionaryType, items: resp.data })
  },
  async [DICTIONARIES.ACTIONS.GET_BASISES_DICTIONARY_ITEMS] ({ dispatch, commit }, model) {
    const dictionaryType = model.dictionaryType
    model = {
      url: `${Vue.getBusinessHost()}${URL_PRODUCTS}/basises?${Vue.helpers.getQueryParamsString(model.params)}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(DICTIONARIES.MUTATIONS.GET_DICTIONARY_ITEMS, { dictionaryType, items: resp.data })
  },
  async [DICTIONARIES.ACTIONS.CLEAR_DICTIONARY_ITEMS] ({ commit }, dictionaryType) {
    commit(DICTIONARIES.MUTATIONS.CLEAR_DICTIONARY_ITEMS, dictionaryType)
  }
}

const mutations = {
  [DICTIONARIES.MUTATIONS.GET_DICTIONARY_ITEMS] (state, model) {
    state[model.dictionaryType] = model.items
  },
  [DICTIONARIES.MUTATIONS.CLEAR_DICTIONARY_ITEMS] (state, dictionaryType) {
    state[dictionaryType] = null
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
